import Box from "@mui/material/Box";

import ActionButton from "Components/Shared/button";
import { request } from "Utils";
import { useState } from "react";
import Progress from "Components/Shared/loading";
import DialogComponent from "Components/Shared/dailog";
import { useMutation } from "react-query";
import { Typography } from "@mui/material";
import { RestAccountFunc } from "./type";

const RestAccount: RestAccountFunc = ({
  toggleToast,
  isOpen,
  closeDialog,
  url,
  refetch,
  status,
}) => {
  const [isLoading, setIsloading] = useState(false);
  const validate = status === "ACTIVE" ? "BLOCK" : "ACTIVATE";

  const mutation = useMutation(async () => {
      setIsloading(true);
      return await request.patch({
        url,
        data: { status: validate === "ACTIVATE" ? "ACTIVE" : "BLOCKED" },
      });
    },
    {
      onSuccess: ({ message }) => {
        toggleToast(message);
        refetch && refetch();
        setIsloading(false);
        closeDialog();
      },
      onError: ({ message }) => {
        toggleToast(message);
        setIsloading(false);
      },
  });
  return (
    <div>
      <DialogComponent
        open={isOpen}
        onClose={closeDialog}
        title="Reset account"
        maxWidth="xs"
      >
        <Box py={2}>
          <Typography variant="body1" sx={{ fontSize: 16, lineHeight: 1.6 }}>
            This account is currently <strong>{status}</strong> are you sure you
            want to <strong>{validate}</strong> ?
          </Typography>
          <Box textAlign="right">
            <ActionButton
              onClick={() => mutation.mutate()}
              sx={{
                color: validate === "BLOCK" ? "red" : "green",
                fontSize: 16,
              }}
            >
              Yes, {validate}{" "}
              {isLoading && (
                <Progress sx={{ color: "#fff", ml: 0.8 }} size={18} />
              )}
            </ActionButton>
            <ActionButton
              onClick={() => closeDialog()}
              sx={{ color: "#616161", fontSize: 16 }}
            >
              No, Cancel
            </ActionButton>
          </Box>
        </Box>
      </DialogComponent>
    </div>
  );
};
export default RestAccount;
